import { createSelector } from 'reselect';

import { getContentType } from './getMatch';
import { createGetContentItemBySlug } from './createGetContentItem';

const getActiveContentItemBySlug = createSelector(
  [getContentType],
  (contentType) => createGetContentItemBySlug(contentType),
);

// eslint-disable-next-line import/prefer-default-export -- incompatible with our future rules
export const getActiveContentItem = createSelector(
  [
    getActiveContentItemBySlug,
    // This sucks for memoization, but getItem for now is made in a way that doesn't get better than that
    (state) => state,
  ],
  (getItem, state) => getItem(state),
);
